// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ViewProps } from 'react-native';
import type { DirectEventHandler, Int32, Double } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
type UiMapMarker = Readonly<{
  id: string;
  title: string;
  latitude: Double;
  longitude: Double;
  tint: string;
}>;
interface NativeProps extends ViewProps {
  latitude: Double;
  longitude: Double;
  zoom: Double;
  markers: ReadonlyArray<UiMapMarker>;
  overlays: string;
  onNativeUiMapCameraMove?: DirectEventHandler<Readonly<{
    latitude: Double;
    longitude: Double;
    zoom: Double;
  }>>;
  onNativeUiMapMarkerClick?: DirectEventHandler<Readonly<{
    id: string;
  }>>;
  onNativeUiMapClick?: DirectEventHandler<Readonly<{
    latitude: Double;
    longitude: Double;
  }>>;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
let nativeComponentName = 'OneNativeUiMap';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeUiMap",
  directEventTypes: {
    topNativeUiMapCameraMove: {
      registrationName: "onNativeUiMapCameraMove"
    },
    topNativeUiMapMarkerClick: {
      registrationName: "onNativeUiMapMarkerClick"
    },
    topNativeUiMapClick: {
      registrationName: "onNativeUiMapClick"
    }
  },
  validAttributes: {
    latitude: true,
    longitude: true,
    zoom: true,
    markers: true,
    overlays: true,
    ...ConditionallyIgnoredEventHandlers({
      onNativeUiMapCameraMove: true,
      onNativeUiMapMarkerClick: true,
      onNativeUiMapClick: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);